/**
 * Правила фото профиля — одни на старую карточку загрузки и на поле фото в
 * данных CV (0072): png/jpeg, до 5 МБ, сторона до 1240 px. Сервер проверяет
 * то же самое (`profile._validate_photo`); здесь — чтобы не гонять файл зря.
 */
const ALLOWED = /(\.jpeg|\.png|\.jpg)$/i;
const MAX_SIZE = 5242880;
const MAX_SIDE = 1240;

export const validatePhotoFile = (file: File): Promise<boolean> =>
  new Promise((resolve) => {
    if (!ALLOWED.test(file.name) || file.size > MAX_SIZE) {
      resolve(false);
      return;
    }
    const src = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      URL.revokeObjectURL(src);
      resolve(img.width <= MAX_SIDE && img.height <= MAX_SIDE);
    };
    img.onerror = () => {
      URL.revokeObjectURL(src);
      resolve(false);
    };
    img.src = src;
  });
